import script from "./forgetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./forgetPassword.vue?vue&type=script&setup=true&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=88900e5c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88900e5c"]])

export default __exports__